module.exports = __webpack_public_path__ + "static/img/torso6.4a7beb98.jpg";